export default __webpack_public_path__ + "static/media/479.2f2c3ad9.jpg";